module.exports = __webpack_public_path__ + "img/icon_order_wait.c3536f1b.png";